import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const HeaderWrapper = styled.div<{ mainBg: string }>`
    position: relative;
    width: 100%;
    margin-bottom: 176px;
    background-image: url(${p => p.mainBg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-bottom: 88px;
        background-position: -100px 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 132px;
        background-position: -150px 0;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 32px;
        background-position: -320px 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 67px;
        background-position: center;
    }
`;

export const HeaderContainer = styled(WideContainer)`
    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column-reverse;
    }
`;

export const ContentBlock = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    height: 630px;
    padding-top: 56px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        height: 520px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        height: 470px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 320px;
        padding-top: 46px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
        height: auto;
        padding: 0 8px 24px;
    }
`;

export const CityDataBlock = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 146px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-bottom: 100px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 50px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 24px;
    }
`;

export const LogoBlock = styled.a`
    width: 173px;
    height: 26px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 107px;
        height: 16px;
    }
`;

export const CitySelectionBlock = styled.div`
    position: relative;
    align-items: center;
    margin-left: 32px;
    padding-left: 18px;
    ${FONTS.MediumXXS};
    color: ${COLORS.TextHint};
    transition: color .25s;
    cursor: pointer;
    white-space: nowrap;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 11px;
        height: 13px;
        background-color: ${COLORS.GRAY_DARK};
        mask-image: url('/static/images/icons/baloon.svg');
        mask-size: contain;
        mask-position: center;
        mask-repeat: no-repeat;
        transition: background-color .25s;
    }

    &:hover {
        color: ${COLORS.Logo};

        &:before {
            background-color: ${COLORS.Logo};
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-left: auto;
    }
`;

export const Logo = styled.img`
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: contain;
`;

export const Title = styled.h1`
    ${FONTS.H0};
    margin-top: 0;
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H1};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H2};
    }
`;

export const Description = styled.p`
    max-width: 570px;
    ${FONTS.L};
    margin-bottom: 24px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.M};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: 490px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
    }
`;

export const RewardSum = styled.span`
    ${FONTS.XXL};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.M};
    }
`;

export const ActionsBlock = styled.div`
    flex-wrap: nowrap;
`;

export const Action = styled(BaseButton)`
    &:not(:last-child) {
        margin-right: 16px;
    }
`;

export const ImageBlock = styled.div`
    position: absolute;
    top: 70px;
    right: 110px;
    width: 805px;
    height: 700px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        top: 63px;
        right: 71px;
        width: 587px;
        height: 511px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        top: 72px;
        right: -14px;
        width: 513px;
        height: 447px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        top: 46px;
        right: -31px;
        width: 478px;
        height: 416px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: static;
        max-width: 330px;
        max-height: 330px;
        margin: 10px auto;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        max-width: 300px;
        max-height: 300px;
    }
`;

export const HeaderImage = styled.img`
    width: 100%;
    height: 100%;
    object-position: center;
    oblect-fit: contain;
`;
